import Vue from 'vue'
import VueRouter from 'vue-router'
import UiKit from '@/containers/ui-kit'
import OfferForm from '@/containers/offer-form'
import NotFound from '@/containers/not-found'
import Unauthorised from '@/containers/unauthorised'
import Admin from '@/containers/admin'

Vue.use(VueRouter)

const routes = [
  {
    path: '/offers/:offerId',
    name: 'Oferta',
    component: OfferForm,
    query: { role: 'evaluator' },
  },
  {
    path: '/401',
    name: 'Usuario no autorizado',
    component: Unauthorised,
  },
  {
    path: '/404',
    name: 'Página no encontrada',
    component: NotFound,
  },
  {
    path: '/admin',
    name: 'Administración de Ofertas',
    component: Admin,
    query: { role: 'admin' },
  },
  {
    path: '/ui-kit',
    name: 'Ui Kit',
    component: UiKit,
  },

  { path: '*', redirect: '/404' },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
